import { cn } from '@/lib/cn';

/*
 * The brand mark: a bill. An ink sheet with its top corner folded down, and
 * a "B" set in straight folds, no curves, so the letter and the crease are
 * drawn in the same hand. The flap is the sheet's underside, a few tenths
 * of the ink on it. The geometry is shared with public/favicon.svg and the
 * website's Logo.astro; change all three together.
 */
export const MARK_SHEET = 'M6 0h16l10 10v16a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6Z';
export const MARK_FLAP = '22,0 32,10 22,10';
export const MARK_LETTER =
  'M9 8h10.5L22 10.5V12l-2.5 2.5H21l2.5 2.5v4.75L21 24.25H9Z' +
  'M12.25 11h6.15l.6.6v2.3l-.6.6h-6.15Z' +
  'M12.25 17.25h7.65l.6.6v2.8l-.6.6h-7.65Z';

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn('size-[1.375rem]', className)}>
      <path d={MARK_SHEET} className="fill-[var(--bp-primary)]" />
      <g className="fill-[var(--bp-on-primary)]">
        <polygon points={MARK_FLAP} fillOpacity={0.3} />
        <path d={MARK_LETTER} fillRule="evenodd" />
      </g>
    </svg>
  );
}
